import { useDispatch, useSelector } from "react-redux";
import { fetchSinglePost } from "../../features/BlogDetails/blogDetailsSlice";

export default function PostDetails() {
  const dispatch = useDispatch();
  const post = useSelector((state) => state.blogsDetails.post);

  if (!post) return null;

  const { title, description, image, tags, likes, isSaved, id } = post;

  const handleLike = async () => {
    try {
      await fetch(`http://localhost:9000/blogs/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ likes: likes + 1 }),
      });

      dispatch(fetchSinglePost(id));
    } catch (error) {
      alert(error);
    }
  };

  const handleToggleSave = async () => {
    try {
      await fetch(`http://localhost:9000/blogs/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ isSaved: !isSaved }),
      });

      dispatch(fetchSinglePost(id));
    } catch (error) {
      alert(error);
    }
  };

  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tags.map((tag) => (
            <>
              <span key={tag}>#{tag},</span>{" "}
            </>
          ))}
        </div>
        <div className="btn-group">
          {/* handle like on button click */}
          <button
            className="like-btn"
            id="lws-singleLinks"
            onClick={handleLike}
          >
            <i className="fa-regular fa-thumbs-up" /> {likes}
          </button>
          <button
            className={`save-btn ${isSaved ? "active" : ""}`}
            id="lws-singleSavedBtn"
            onClick={handleToggleSave}
          >
            <i className="fa-regular fa-bookmark" />{" "}
            {isSaved ? "Saved" : "Save"}
          </button>
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
}
